<template>
  <v-app>
    <v-card
      row
      align-center
      style="max-width: 640px; width: 100%"
      class="mx-auto mt-3"
    >
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Register</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row justify="space-around">
          <v-col class="text-center">
            <span>Already have an account?</span>
            <v-spacer />
            <v-btn color="primary" dark to="/login">Log in</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-container>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Company's representative</v-toolbar-title>
            </v-toolbar>
            <v-text-field
              color="primary"
              label="Company name"
              required
              v-model="customer.data.company"
              :error-messages="CustomerNameErros"
              @input="$v.customer.data.company.$touch()"
              @blur="$v.customer.data.company.$touch()"
            ></v-text-field>

            <v-text-field
              color="primary"
              label="First name"
              required
              v-model="customer.data.firstname"
              :error-messages="CustomerFirstNameErrors"
              @input="$v.customer.data.firstname.$touch()"
              @blur="$v.customer.data.firstname.$touch()"
            ></v-text-field>
            <v-text-field
              color="primary"
              label="Last name"
              required
              v-model="customer.data.lastname"
              :error-messages="CustomerLastNameErrors"
              @input="$v.customer.data.lastname.$touch()"
              @blur="$v.customer.data.lastname.$touch()"
            ></v-text-field>
            <v-text-field
              color="primary"
              label="E-mail"
              required
              v-model="customer.data.email"
              :error-messages="CustomerEmailErrors"
              @input="$v.customer.data.email.$touch()"
              @blur="$v.customer.data.email.$touch()"
            ></v-text-field>
            <v-text-field
              color="primary"
              label="Password"
              required
              :append-icon="!customer.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="customer.showpassword ? 'text' : 'password'"
              v-model="customer.data.password"
              :error-messages="CustomerPasswordErrors"
              @input="$v.customer.data.password.$touch()"
              @blur="$v.customer.data.password.$touch()"
              class="input-group--focused"
              @click:append="customer.showpassword = !customer.showpassword"
            ></v-text-field>
            <v-text-field
              color="primary"
              label="Confirm password"
              required
              :append-icon="
                !customer.showconfirmpassword ? 'mdi-eye-off' : 'mdi-eye'
              "
              :type="customer.showconfirmpassword ? 'text' : 'password'"
              v-model="customer.data.confirmpassword"
              :error-messages="CustomerConfirmPasswordErrors"
              @input="$v.customer.data.confirmpassword.$touch()"
              @blur="$v.customer.data.confirmpassword.$touch()"
              class="input-group--focused"
              @click:append="
                customer.showconfirmpassword = !customer.showconfirmpassword
              "
            ></v-text-field>
            <p></p>
            <v-autocomplete
              
              v-model="customer.data.utcoffset"
              :items="timezones"
              :loading="isLoading"
              :search-input.sync="search"
              color="primary"
              hide-no-data
              hide-selected
              item-text="Description"
              item-value="API"
              label="Timezones"
              placeholder="Start typing to Search"
              append-icon="mdi-map-marker"
              return-object
              clearable
              :error-messages="TimezoneErrors"
              @input="$v.customer.data.utcoffset.$touch()"
              @blur="$v.customer.data.utcoffset.$touch()"
              @change="calculateUtcOffset"
            ></v-autocomplete>
            <v-row justify="center">
              <vue-tel-input
                v-model="customer.data.phone"
                @onInput="onInput"
                @onBlur="validate"
                required
              ></vue-tel-input>
              <template v-if="isValidPhoneNumber">
                <v-icon color="green">mdi-check</v-icon>
              </template>
            </v-row>
          </v-container>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center">
          <v-btn justify="center" color="primary" dark @click="signup()"
            >Register</v-btn
          >
        </v-row>
      </v-card-actions>
      <v-divider></v-divider>
      <v-spacer></v-spacer>
      <v-row justify="center">
        <v-col cols="8" class="text-center">
          <p>
            This page is protected by reCAPTCHA, and subject to
            <a href="https://policies.google.com/privacy"
              >Google’s Privacy Policy</a
            >
            & <a href="https://policies.google.com/terms">Terms of Service</a>.
          </p>
        </v-col>
      </v-row>
    </v-card>
  </v-app>
</template>
<script>
//import { validationMixin } from "vuelidate";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
// import ThankYouVue from "./ThankYou.vue";
import { VueTelInput } from "vue-tel-input";
import axios from "axios";
import momentTimeZone from 'moment-timezone';

export default {
  name: "Register",
  components: {
    VueTelInput,
  },
  validations: {
    customer: {
      data: {
        firstname: { required, minLength: minLength(2) },
        lastname: { required, minLength: minLength(2) },
        email: { email, required },
        password: { required, minLength: minLength(8) },
        confirmpassword: { sameAsPassword: sameAs("password") },
        company: { required },
        utcoffset: { required },
      },
    },
  },
  created() {},
  mounted() {
    this.cbInstance = window.Chargebee.init({ site: "hairpointments" });
    this.getTimeZones();
  },

  data: () => ({
    isValid: false,
    isValidPhoneNumber: false,
    timezones: [],
    timezone: null,
    isLoading: false,
    search: null,
    offset: null,

    customer: {
      data: {
        company: null,
        email: null,
        firstname: null,
        lastname: null,
        password: null,
        utcoffset: null,
      },
      showpassword: false,
      confirmpassword: false,
      showconfirmpassword: false,
    },
  }),

  computed: {
    CustomerNameErros() {
      const errors = [];
      if (!this.$v.customer.data.company.$dirty) return errors;
      !this.$v.customer.data.company.required &&
        errors.push("Name is required.");
      return errors;
    },
    CustomerFirstNameErrors() {
      const errors = [];
      if (!this.$v.customer.data.firstname.$dirty) return errors;
      !this.$v.customer.data.firstname.required &&
        errors.push("Firstname is required.");
      !this.$v.customer.data.firstname.minLength &&
        errors.push("Minimum length is 2 charachters.");
      return errors;
    },
    CustomerLastNameErrors() {
      const errors = [];
      if (!this.$v.customer.data.lastname.$dirty) return errors;
      !this.$v.customer.data.lastname.required &&
        errors.push("Lastname is required.");
      !this.$v.customer.data.lastname.minLength &&
        errors.push("Minimum length is 2 charachters.");
      return errors;
    },
    CustomerEmailErrors() {
      const errors = [];
      if (!this.$v.customer.data.email.$dirty) return errors;
      !this.$v.customer.data.email.required &&
        errors.push("E-mail is required");
      !this.$v.customer.data.email.email && errors.push("Must be valid e-mail");

      return errors;
    },
    CustomerPasswordErrors() {
      const errors = [];
      if (!this.$v.customer.data.password.$dirty) return errors;
      !this.$v.customer.data.password.minLength &&
        errors.push("8 characters at least");
      !this.$v.customer.data.password.required &&
        errors.push("Password is required.");
      return errors;
    },
    CustomerConfirmPasswordErrors() {
      const errors = [];
      if (!this.$v.customer.data.confirmpassword.$dirty) return errors;
      !this.$v.customer.data.confirmpassword.sameAsPassword &&
        errors.push("Passwords has to match.");
      return errors;
    },
    TimezoneErrors() {
      const errors = [];
      if (!this.$v.customer.data.utcoffset.$dirty) return errors;
      !this.$v.customer.data.utcoffset.required &&
        errors.push("Timezone is required");
      return errors;
    },
  },

  methods: {
    calculateUtcOffset(event) {
      this.offset = momentTimeZone.tz(event)._offset * 60;
    },
    signup() {
      this.$v.$touch();
      // if (this.checkPhoneNumbers() == false) {
      //   this.showError("Phonenumber is mandatory!");
      //   return;
      // }
      if (!this.isValidPhoneNumber) {
        this.showError("Phonenumber is mandatory!");
        return;
      }
      if (this.$v.$invalid) {
        return;
      }
      // this.$store.dispatch("verifyRecapthca", "signup").then((result) => {
      //   // handle verify recaptcha

      //   if (result.data.errorMessage) {
      //     this._vm.showError(result.data.errorMessage);
      //     return;
      //   } else if (result.data.success) {
          this.checkout();
      //   }
      // });
    },
    async recaptcha() {
      await this.$recaptchaLoaded();
      this.$v.$touch();
      

      if (this.$v.$invalid) {
        return;
      }

      // (optional) Wait until recaptcha has been loaded.
      

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha("login");
      if (token != null) {
        this.CheckMail(token);
      } else {
        alert("reCaptcha validation failed!");
      }

      // Do stuff with the received token.
    },

    // checkPhoneNumbers() {
    //   if (
    //     //this.isValidBillingInfoPhoneNumber == false ||
    //     this.isValidPhoneNumber == false
    //   ) {
    //     return false;
    //   }
    //   return true;
    // },
    // CheckMail() {
    //   axios
    //     .post("/api/checkmail", { value: this.customer.data.email })
    //     .then(response => {
    //       if (!response.data.errorMessage) {
    //         this.checkout();
    //       } else {
    //         this.showError(response.data.errorMessage);
    //       }
    //     })
    //     .catch(error => {
    //       this.showError(error);
    //     });
    // },

    checkout() {
      this.cbInstance.openCheckout({
        hostedPage: () => {
          // Hit your end point that returns hosted page object as response
          // This sample end point will call the below api
          // https://apidocs.chargebee.com/docs/api/hosted_pages#checkout_new_subscription
          // If you want to use paypal, go cardless and plaid, pass embed parameter as false

          return axios
            .post("/api/checkout", {
              customer: this.customer.data,
            })
            .then((response) => {
              return response.data;
            });
        },
        loaded: () => {
          console.log("checkout opened");
        },
        close: () => {
          this.loading = false;
          this.$router.push("/login");
        },
        success: (hostedPageId) => {
          axios
            .post("/api/subscribe", {
              Id: hostedPageId,
              Subscriber: {
                EmailAddress: this.customer.data.email,
                Password: this.customer.data.password,
              },
              utcoffset: this.offset,
            })
            .then(() => {
              // this.$store.dispatch("signup", {
              //   email: this.customer.data.email,
              //   password: this.customer.data.password
              // });
            });
        },
        step: function (value) {
          // value -> which step in checkout
          console.log(value);
        },
        error: function (error) {
          console.log(error);
        },
      });
    },

    onInput({ isValid }) {
      this.isValidPhoneNumber = isValid;
    },
    validate() {
      //   if (!this.isValidPhoneNumber) {
      //   }
    },
    getTimeZones() {
      this.isLoading = true;
      this.timezones = momentTimeZone.tz.names();
      this.isLoading = false;


      // axios
      //   .get("https://worldtimeapi.org/api/timezone")
      //   .then((result) => {
      //     this.timezones = result.data;
      //     this.isLoading = false;
      //   })
      //   .catch((error) => {
      //     this.showError(error);
      //   });
    },
  },
  watch: {
    timezone() {
      if (!this.timezone) {
        return;
      }
      this.customer.data.utcoffset = momentTimeZone.tz(this.timezone)._offset * 60;
      // axios
      //   .get(`https://worldtimeapi.org/api/timezone/${this.timezone}`)
      //   .then((res) => {
      //     this.customer.data.utcoffset = res.data.raw_offset;
      //   })
      //   .catch((err) => {
      //     this.showError(err);
      //   });
    },
  },
};
</script>

<style>
.dropdown.open {
  z-index: 2 !important;
}
.dropdown.open ul {
  overflow-x: scroll;
}
</style>

